import React, { useState } from 'react';
import { createFaq } from '../utils/api';

const FAQForm = ({ onFaqCreated }) => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [language, setLanguage] = useState('');
  const [country, setCountry] = useState('');
  const [category, setCategory] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newFaq = await createFaq({
        question,
        answer,
        language,
        country,
        category,
      });
      onFaqCreated(newFaq);
      setQuestion('');
      setAnswer('');
      setLanguage('');
      setCountry('');
      setCategory('');
      setError(null);
    } catch (err) {
      console.error(err);
      setError('There was an error creating the FAQ.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="faq-form p-3 mb-2 border rounded">
      <div className="mb-3">
        <label htmlFor="question" className="faq-form_label form-label">Question:</label>
        <input
          type="text"
          id="question"
          className="faq-form_input form-control"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label htmlFor="answer" className="faq-form_label form-label">Answer:</label>
        <textarea
          id="answer"
          className="faq-form_textarea form-control"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          required
          rows="3"
        />
      </div>
      <div className="mb-3">
        <label htmlFor="language" className="faq-form_label form-label">Language:</label>
        <input
          type="text"
          id="language"
          className="faq-form_input form-control"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="country" className="faq-form_label form-label">Country:</label>
        <input
          type="text"
          id="country"
          className="faq-form_input form-control"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="category" className="faq-form_label form-label">Category:</label>
        <input
          type="text"
          id="category"
          className="faq-form_input form-control"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
      </div>
      {error && <div className="faq-form_error alert alert-danger" role="alert">{error}</div>}
      <button type="submit" className="faq-form_submit-btn btn btn-primary">Create FAQ</button>
    </form>
  );
};

export default FAQForm;
